export enum EndUserState {
  IDLE = 'IDLE',
  RECORDING = 'RECORDING',
}
